export const calculateStudentNorms = (testingTypeId: number, sex: string) => {
  if (testingTypeId === 1 && sex === 'м') return { KVERIPO: 0.78, IRP: [44, 50] };
  if (testingTypeId === 2 && sex === 'м') return { KVERIPO: 0.70, IRP: [41, 47] };
  if (testingTypeId === 3 && sex === 'м') return { KVERIPO: 0.97, IRP: [41, 50] };

  if (testingTypeId === 1 && sex === 'ж') return { KVERIPO: 0.78, IRP: [44, 50] };
  if (testingTypeId === 2 && sex === 'ж') return { KVERIPO: 0.72, IRP: [42, 46] };
  
  return { KVERIPO: 0.75, IRP: [43, 51] };
};

export const calculateStudentResults = (
  KVERIPO: number,
  IRP: number,
  norms: { KVERIPO: number; IRP: [number, number] },
) => {
  if (IRP > norms.IRP[1]) return 2;
  if (IRP >= norms.IRP[0]) return 1;
  
  return 0;
};
